import { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Modal } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';

import styles from './MobileSignupHelpModal.module.css';
import {
  getAmplitudeDefaultEventProperties,
  getAmplitudeDeviceCategory,
  SIGNUP_FLOW_DE_MOBILE,
} from '../../../utils/amplitudeEvents';
import HelpContents from '../../SidePanel/Help/HelpContents';

type TProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const MobileSignupHelpModal = ({ isOpen, onClose }: TProps) => {
  const { t } = useLingui();

  useEffect(() => {
    if (!isOpen) return;
    tracking.ampli.helpModalViewed({
      client_device: getAmplitudeDeviceCategory(),
      signup_flow: SIGNUP_FLOW_DE_MOBILE,
      ...getAmplitudeDefaultEventProperties(),
    });
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t`Still need help?`}
      closeIcon
      className={styles.modal}
    >
      <div className={styles.contents}>
        <HelpContents />
      </div>
    </Modal>
  );
};
